module.exports = __webpack_public_path__ + "static/media/portfolio3.ca5ebde0.jpeg";